import Companies from "../components/Dashboard/Company/Companies";
import CompanyDetails from "../components/Dashboard/Company/CompanyDetails";
import Company from "../components/Dashboard/Company/Company";

const companyRoutes = [
    {
        path: "companies",
        component: Companies,
        meta: {
            required: true,
            roles: ["PanelUser"],
        },
        name: "Companies",
    },
    {
        path: "company",
        component: Company,
        meta: {
            required: true,
            roles: ["PanelUser"],
        },
        name: "Company",
    },
    {
        path: "company/:id",
        component: CompanyDetails,
        meta: {
            required: true,
            roles: ["PanelUser"],
        },
        name: "CompanyDetails",
    },
]

export default companyRoutes;